<template>
  <div :class="{'menu-non-expanded': !menuExpanded, 'menu-expand-container': true}" class="component-body">
    <nav>
      <div class="menu-header" @click="toggleMenu">
        <i class="far fa-bars icon-toggle"></i>
        <h4 v-if="menuExpanded && usuario && usuario.perfilSelecionado && usuario.perfilSelecionado.setor" class="module-text">
          {{ usuario.perfilSelecionado.setor.nome }}
        </h4>
      </div>

      <ul>
        <li v-for="item in items" :key="item.id" v-if="mostrarMenu(item.permissao)">
          <el-tooltip
            effect="dark"
            :content="item.nome"
            :disabled="item.nome.length < 26 && windowWidth > 1365"
            placement="right"
          >
            <div
              class="menu-item"
              :class="{ active: caixaIsActive(item) }"
              @click.stop="goTo(item.routeGroup)"
            >
              <div class="menu-group color-primary" :id="`menu-side-${item.routeGroup}`">
                <i :class="item.icon"></i>
                <div class="menu-text">
                  <p>
                    {{ item.nome.length > 25 ? item.nome.slice(0, 25) + '...' : item.nome }}
                  </p>
                </div>
              </div>
            </div>
          </el-tooltip>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import './styles.scss'
import { mapGetters } from 'vuex'
import PermissaoHelper from '@/utils/PermissaoHelper'

export default {
  name: 'side-menu',
  mixins: [PermissaoHelper],

  props: {
    items: {
      type: Array,
      required: true
    },
    isActiveOnPreviousRoute: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      menuExpanded: true,
      activeMenu: 'CAIXA_DE_ENTRADA',
      windowWidth: 0
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  mounted () {
    window.addEventListener('resize', this.getWindowWidth)
    this.getWindowWidth()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
  },

  methods: {
    goTo (routeGroup) {
      if (this.$route.meta.routeGroup !== routeGroup) {
        this.activeMenu = routeGroup
        this.$router.push({ name: routeGroup })
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }
    },

    mostrarMenu (permissao) {
      const permissoes = this.usuario.permissoes || []
      return !permissao || !!permissoes.find(p => p.codigo === permissao)
    },

    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    },

    toggleMenu () {
      this.menuExpanded = !this.menuExpanded
    },
    caixaIsActive (item) {
      const isRotaAtual = item.routeGroup === this.$route.meta.routeGroup
      const isRotaAnterior = item.routeGroup === this.$route.meta?.previousRoute?.meta?.routeGroup

      return isRotaAtual || (this.isActiveOnPreviousRoute && isRotaAnterior)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components(new)/layout/SideMenu/SideMenu.vue